import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { indiaPhoneValidator, phoneValidator } from 'src/app/shared/validators/phone-validator';
import { PhoneCode } from '../../../../shared/constants/countryPhoneCode.constant';
import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import { AuthService } from '../../../../shared/services/auth.service';
import { CommonService } from '../../../../shared/services/common.service';
import { UtilService } from '../../../../shared/services/util.service';
import { CreateBookingService } from '../../../../bookings/create-booking/create-booking.service';
import { MatTableDataSource } from '@angular/material/table';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { countries } from 'countries-list';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-riders-table',
  templateUrl: './riders-table.component.html',
  styleUrls: ['./riders-table.component.scss']
})
export class RidersTableComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() config: any;
  @Input() formArray: any;
  @Input() tripFormDetails: FormGroup;
  @Input() formDetails: FormGroup;
  @Input() enableAlternateMobileNumber: boolean;
  @Input() riderTypeMapping: any;
  @Input() referenceBooking: any;
  @Input() whatsappComm: any;
  @Input() miscelleneousConfig: any;
  public formConfig: any[] = [];
  public searchConfig: any;
  private currentUser: any;
  public costCenters: any[];
  public departmentList: any[];
  public riderStateArray: any[] = [];
  private emplIdConfig: any;
  private watchers: any[] = [];
  public costCenterNames: any[];
  public costCenterConfig: any;
  public editModeControlHide: any = {};
  private actionControlConfig: any[] = [];
  private bookingEditConfigObj: any;
  private isSelfRider: boolean;
  private riderAddress = [];
  private destroy$ = new Subject();
  phoneCodes = PhoneCode;
  isPhoneCodeConfigVisibile: boolean;
  duplicateRiderMsg: string;
  public paymentType: any;
  public payeeOptions: any[] = [];
  public selectedPayer;
  addnewRiderElm: any;
  etsValuesMandatory = false;
  phoneNumberInEtsMandatory = {};
  payerConfig: any;
  editRiderInfo = false;
  editableCostCenter = false;
  dropdownData: DropdownItem[];
  /** New Ui */
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  searchTerm = '';
  isTyped = true;
  dataSource !: MatTableDataSource<any>;
  styleApplied = "editable-table";
  selectStyleApplied = "editable-table";
/*   @ViewChild(MatSort, {static: false})
  set sort(value: MatSort) {
    this.dataSource.sort = value;
  } */

  displayedColumns: string[] = ['check', 'bookid', 'tripDate', 'tripID', 'time', 'rider', 'startAddress', 'actions'];

  count = 10;
  tableSize = 6;
  tableSizes: any = [1, 3, 6, 9, 12, 20];
  p = 1;
  pageIndex = 6;
  riderGuidList=[];
  selectedCountryCode;
  selectedRider:string = 'Guest';
  whatsappCommunication:boolean=false;
  addRiderConfig:any;
  riderLimitReached:boolean=false;
  riderLimit:number;
  alternateMobileMandatory:boolean=false;
  departmentListName: any = [];
  constructor(private formBuilder: FormBuilder,
              private createBookingService: CreateBookingService,
              private commonService: CommonService,
              private utilService: UtilService,
              private changeDetectorRef: ChangeDetectorRef,
              private authService: AuthService,
              private commonBookingService: CommonBookingService,
  ) {
    super();
  }

  @Input()
  set requester(requester: any) {
        if (requester) {
      this.updateRequester({
        ...requester,
        riderType: this.currentUser.employeeId === requester.emplId ? this.getSelfKey() : requester.RequestorTypeID,
        // riderType:requester.RequestorTypeID,
        riderTypeId: requester.Requester,
        payerGuid: this.selectedPayer
      });
    }
  }  

  @Input()
  set bookingEditConfig(bookingEditConfig: any) {
    if (bookingEditConfig) {
      this.bookingEditConfigObj = bookingEditConfig;
      this.recheckButtonVisibility();
    }
  }

  getPhoneCodeValue(option) {
    return option ? option.dial_code : '';

  }

  getPhoneCodeLabel(option) {
    return option ? `${option.dial_code} - ${option.name}` : 'Select';

  }

  recheckButtonVisibility = () => {
    if (this.bookingEditConfigObj) {
      this.actionControlConfig.forEach((config) => {
        this.editModeControlHide[config.elementKey] = !this.checkButtonVisibilityForEdit(config, this.bookingEditConfigObj);
      });
    }
  }

  ngOnInit() {
    this.getCurrentUser().subscribe(()=>{
      const alternatePhoneCodeElement = this.config.elementConfigList.find(element => element.elementKey === "alternatePhoneCode");
      if (alternatePhoneCodeElement) {
          this.alternateMobileMandatory = alternatePhoneCodeElement.config.mandatory;
      }
      this.config.elementConfigList.forEach(ele => {
        if (ele.elementKey == "AddRiderRow"){
          this.addRiderConfig = {
            visibility: ele.config.visibility.visible,
            displayName: ele.config.displayName,
            key: ele.elementKey
          };
        }
      });
      // this.showNumberOfRecords(6);

      this.commonBookingService.savedAddressesForRiders.
        pipe(
          takeUntil(this.destroy$),
        )
        .subscribe((address) => {
          if (address) {
            this.riderAddress = address;
          }
        });
      this.commonBookingService.selectedPayer.
        pipe(
          takeUntil(this.destroy$),
        )
        .subscribe((type) => {
          if (type) {
            this.selectedPayer = type;
            this.formArray.controls.forEach((control) => {
              if (control.get('emplGuid').value === this.selectedPayer) {
                control.get('payerGuid').setValue(this.selectedPayer);
              } else {
                control.get('payerGuid').setValue("");
              }
            });
          } else {
            this.selectedPayer = type;
            this.formArray.controls.forEach((control) => {
              control.get('payerGuid').value = '';
            });
          }
        });

      this.getConfig();
      this.commonBookingService.paymentType.
        pipe(
          takeUntil(this.destroy$),
        )
        .subscribe((type) => {
          if (type) {
            this.paymentType = type;
            if (type === 'Bill To User') {
              this.constructPayeeForm(this.formArray);
            } else {
              this.commonBookingService.getSelectedPayer(null);
            }
          }
        });
      this.getCostCenters();
      this.getDepartments();
      this.recheckButtonVisibility();
      const addnewRiderConfig = this.commonService.getConfigForElementKey(this.config.elementConfigList, 'AddRiderRow');
      this.addnewRiderElm =  addnewRiderConfig.config.displayName;
      this.riderLimit = this.commonService.workflowConfig?.riderLimit;


      // console.log('this.riderStateArray => 0', this.riderStateArray);
      this.dropdownData = Object.values(countries).map((item: any) => ({
        label: `+ ${item.phone} ${item.name}`,
        value: item.phone
      }));
      if (this.referenceBooking?.whatsappCommunication) { this.whatsappCommunication = this.referenceBooking?.whatsappCommunication; }
    });
  }


  setupForm() {
         if ( !this.formArray.length  && this.authService.user.role.toLowerCase().includes('employee') && this.commonService.workflowConfig?.addSelfAsDefaultRider) {
      this.addSelfAsRider();
    } else if (!this.formArray.length  && this.commonService.workflowConfig?.addSelfAsDefaultRider){
      this.addSelfAsRider();
    }else{
      this.formArray.controls.forEach((formGroup) => {
        if (this.isPhoneCodeConfigVisibile) {
          const mobileAndCountryCode = this.getPhoneAndCountryCode(formGroup.controls.mobile.value, formGroup.controls.phoneCode.value);
          formGroup.patchValue({ phoneCode: mobileAndCountryCode[0] });
          formGroup.patchValue({ mobile: mobileAndCountryCode[1] });
          if (mobileAndCountryCode[0] === '+91') {
            formGroup.get('mobile').setValidators([Validators.required, indiaPhoneValidator]);
            this.alternateMobileMandatory ?
            formGroup.get('alternateMobile')?.setValidators([Validators.required, indiaPhoneValidator]) :
            formGroup.get('alternateMobile')?.setValidators([indiaPhoneValidator]);
          } else {
            if (formGroup.get('mobile').hasError('phone')) {
              formGroup.get('mobile').setErrors(null);
              formGroup.get('mobile').setValidators([Validators.required]);
            }
          }
        }
        this.riderStateArray.push({
          isEditActive: false
        });
        this.setEmplIdValidator(formGroup, formGroup.get('riderType').value);
        if (formGroup.get('phoneCode')) {
          formGroup.get('phoneCode').valueChanges.subscribe((code) => {
            if (code === '+91') {
              formGroup.controls['mobile'].setValidators([Validators.required, indiaPhoneValidator]);
              this.alternateMobileMandatory ?
              formGroup.get('alternateMobile')?.setValidators([Validators.required, indiaPhoneValidator]) :
              formGroup.get('alternateMobile')?.setValidators([indiaPhoneValidator]);
            } else {
              formGroup.controls['mobile'].setValidators(Validators.required);
            }
            formGroup.controls['mobile'].updateValueAndValidity();
          });
        }
      });
    }
  }

  getPhoneAndCountryCode(mobile, code?: string): string[] {
    let phoneCode = "";
    let phoneNumber = "";
    if (mobile && !mobile.startsWith("+")) {
      if (code && code !== "") {
        phoneCode = code;
      } else {
        phoneCode = "+91";
      }
      phoneNumber = mobile;
    } else {
      if (mobile) {
        const phoneWithCode = mobile.split('-');
        phoneCode = phoneWithCode[0];
        phoneNumber = phoneWithCode[1];
      }
    }
    return [phoneCode, phoneNumber];
  }

  getCostCenters() {
    this.commonService.getEtsData().subscribe((response) => {
      this.commonService.costcenter.next(response.costCenters);
      this.commonService.costcenter.subscribe(response => {
        this.costCenters = response;
        this.costCenterNames = this.costCenters.map((costCenter: any) => {
          return costCenter.name;
        });
      });
      this.setupForm();
    });
  }
  getDepartments() {
    this.commonService.getEtsData().subscribe((response) => {
        this.departmentList = response.departments;
        this.departmentListName = response.departments.map((departmemt: any) => {
          return departmemt.name;
        });
    });
  }
  getCostCenterAndDepartmemntLabelFromValue(value: string, isDepartment: boolean = false): string {
    let temp = this.costCenters;
    if(isDepartment){
      temp = this.departmentList;
    }
    if(temp?.length){
      for (const elememt of temp) {
        if (elememt.guid === value) {
          return elememt.name;
        }
      }
    }
  }

  getCurrentUser() {
    return new Observable((obs)=>{
    this.authService.getUserInfo().subscribe((response) => {
      this.currentUser = response.employee;
      if (this.miscelleneousConfig && this.miscelleneousConfig['etsValuesMandatory']) {
          this.etsValuesMandatory = this.miscelleneousConfig['etsValuesMandatory'] === 'false' ? false : true;
          this.editableCostCenter = this.miscelleneousConfig['enableEditableCostCenter'];
        }
      obs.next();
      obs.complete();
      });
    });

  }

  getConfig() {
    for (const element of this.config.elementConfigList) {
      if (element.elementKey !== 'RiderSearch' && element.config.elementType !== 'button' &&
        element.elementKey !== 'Rider Serial Number' && element.elementKey !== 'phoneCode') {
        this.formConfig.push(element);
      }
      if (element.elementKey === 'emplId') {
        this.emplIdConfig = element;
      }
      if (element.elementKey === 'phoneCode') {
        this.isPhoneCodeConfigVisibile = element.config.visibility.visible;
        if (element.config.visibility.visible) {
          this.formConfig.push(element);
        }
      }
      if (element.elementKey === 'costCenter') {
        this.costCenterConfig = element;
      }
      if (element.elementKey === 'RiderSearch') {
        this.searchConfig = element;
      }
      if (element.elementKey === 'RiderSearch' || element.config.elementType === 'button') {
        this.actionControlConfig.push(element);
      }
      if (element.elementKey === 'payer') {
        this.payerConfig = element;
      }
    }
    if (this.formArray.value.length) {
      this.constructPayeeForm(this.formArray);
    }
  }

  addSelfAsRider() {
       this.updateTableWithRider(this.formatRiderInfo(this.currentUser, 'Self'));
    if (this.etsValuesMandatory && this.getConfigForElementKey(this.formConfig, 'mobile').config.visibility.visible) {
      this.checkMobileNumberInEts(0);
    }
  }

  checkMobileNumberInEts(index) {
    setTimeout(() => {
      if (this.getConfigForElementKey(this.formConfig, 'mobile').config.visibility.visible) {
        this.phoneNumberInEtsMandatory[index] = false;
        if (this.formArray.controls[index].get('riderTypeId').value !== 'Firm Member'
          && !this.formArray.controls[index].get('mobile').value) {
          this.phoneNumberInEtsMandatory[index] = true;
          this.formArray.controls[index].get('mobile').setErrors({ etsMobileMandate: true });
          this.formArray.controls[index].get('mobile').markAsDirty();
        }
      }
    }, 0);
  }

  formatRiderInfo(riderDetails: any, riderType: string): any {
    const mobileAndCountryCode = this.getPhoneAndCountryCode(riderDetails.phone);
    return {
      riderType,
      riderTypeId: 'Firm Member',
      name: riderDetails.employeeName,
      emplId: riderDetails.employeeId,
      gender: this.utilService.capitalizeString(riderDetails.gender),
      department: this.getCostCenterAndDepartmemntLabelFromValue(riderDetails.departmentGuid,true),
      costCenter: this.getCostCenterAndDepartmemntLabelFromValue(riderDetails.costCenterGuid),
      email: riderDetails.emailId,
      mobile: mobileAndCountryCode[1],
      phoneCode: mobileAndCountryCode[0],
      emplGuid: riderDetails.guid,
      payerGuid: this.selectedPayer,
      designation: riderDetails.jobTitle,
      officeGuid: riderDetails.office.guid,
      businessUnit: riderDetails.businessUnit,
      jobTitle:riderDetails.jobTitle
    };
  }

  updateRequester(requester: any) {
    this.updateTableWithRider(requester);
  }

  riderSearch = (searchQuery: string) => {
    searchQuery = searchQuery.replace(/;/g, '');
    return this.createBookingService.fetchEmployees(searchQuery);
  }

  isTableCellVisible(config: any): boolean {
    return Boolean(config.config.visibility.elementKey || config.config.visibility.visible);
  }

  onRiderTypeChange(riderForm: any, riderState: any, event, index) {

    this.selectedRider = event.label;
    riderForm.get('riderType').setValue(event.label);
    riderForm.get('riderTypeId').setValue(event.value);

    if (event.value === 'Self' && !this.isSelfRider) {
      this.onSelfSelect(riderForm, riderState, index, event.label);
    }
    this.setEmplIdValidator(riderForm, event.value);
    if (this.payeeOptions[index]) {
      this.payeeOptions[index].payerType = event.value;
    }

  }

  onSelfSelect(riderForm: any, riderState: any, index, riderType) {
    const riderInfo = this.formatRiderInfo(this.currentUser, riderType);
    riderForm.patchValue(riderInfo);
    riderForm.disable({ onlySelf: true });
    this.changeDetectorRef.detectChanges();
    this.isSelfRider = true;
    riderState.isEditActive = true;
    if (this.etsValuesMandatory && !riderForm.controls['mobile'].value) {
      riderForm.get('mobile').enable();
      this.checkMobileNumberInEts(index);
    }
  }

  setEmplIdValidator(riderForm: any, riderTypeId: string) {
    const parent = riderForm;
    let tempEmplIdConfig;
    let tempCostCenterConfig;
    const emplIdControl = parent.get('emplId');
    const costCenterControl = parent.get('costCenter');
    if (emplIdControl) {
      if (riderTypeId === 'Guest') {
        tempEmplIdConfig = Object.assign({}, this.emplIdConfig.config, { mandatory: false });
        tempCostCenterConfig = Object.assign({}, this.costCenterConfig.config, { mandatory: false });
      } else {
        tempEmplIdConfig = this.emplIdConfig.config;
        tempCostCenterConfig = this.costCenterConfig.config;
      }
      emplIdControl.setValidators(this.getValidations(tempEmplIdConfig, parent));
      emplIdControl.updateValueAndValidity();

      costCenterControl.setValidators(this.getValidations(tempCostCenterConfig, parent));
      costCenterControl.updateValueAndValidity();
    }
  }

  updateTableWithRider(riderInfo?: any) {
        // check if added rider is self
    if (riderInfo && riderInfo.riderType === 'Self') {
      riderInfo.riderTypeId = 'Self';
      this.isSelfRider = true;
    }

    // when a rider already in the table is added
    if (riderInfo) {
      for (const control of this.formArray.controls) {
                if (riderInfo.emplId === control.value.emplId) {
          control.patchValue(riderInfo);
          return;
        }
      }
    }

    // when new rider is added
    const formDetails = this.addNewRider(riderInfo);
    this.addRiderState(formDetails, riderInfo);
  }

  addEmptyRiderForm() {
    this.editRiderInfo = false;
    this.updateTableWithRider();
  }

  addNewRider(riderInfo?: any): FormGroup {
       this.selectedRider = this.getGuestKey();
    // when a new rider is added intiate a new form
       const travellerId = this.utilService.generateUuid();
       const formDetails: any = this.formBuilder.group({
      travellerId,
      isNew: true,
      riderType: this.getGuestKey()
    });
       this.constructForm(formDetails, this.formConfig);
       formDetails.addControl('emplGuid', new FormControl(''));
       formDetails.addControl('payerGuid', new FormControl(''));
       formDetails.addControl('officeGuid', new FormControl(''));
       formDetails.addControl('designation', new FormControl(''));
       formDetails.addControl('riderTypeId', new FormControl('Guest'));
       formDetails.addControl('jobTitle', new FormControl(''));

       if (riderInfo) {
      formDetails.patchValue(riderInfo);
    }
    // formDetails.patchValue({phoneCode: "+91"});
       this.createBookingService.newRiders.push(travellerId);
       this.formArray.push(formDetails);
       if (formDetails.get('phoneCode')) {
      formDetails.get('phoneCode').valueChanges.subscribe((code) => {
        if (code === '+91') {
          formDetails.controls['mobile'].setValidators([Validators.required, indiaPhoneValidator]);
          this.alternateMobileMandatory ?
            formDetails.get('alternateMobile')?.setValidators([Validators.required, indiaPhoneValidator]) :
            formDetails.get('alternateMobile')?.setValidators([indiaPhoneValidator]);
        } else {
          formDetails.controls['mobile'].setValidators(Validators.required);
        }
        formDetails.controls['mobile'].updateValueAndValidity();
      });
    }
       if (this.commonService.workflowConfig?.hideOtherRiderMobileNumber && riderInfo){
    for (const config of this.formConfig) {
      if (['mobile', 'alternateMobile'].includes(config.elementKey)){
        if (this.currentUser && this.currentUser?.employeeId !== riderInfo.emplId){
          formDetails.controls[config.elementKey].isHidden = true;
        }else{
          formDetails.controls[config.elementKey].isHidden = false;
        }
      }
    }
  }
       this.constructPayeeForm(this.formArray);
       const riderform = this.formArray.controls;
       riderform.forEach((control) => {

  });

       if (this.commonService.workflowConfig.riderLimit) {
    this.riderLimitReached = this.formArray.length == this.commonService.workflowConfig.riderLimit ? true : false;
   }
       return formDetails;
  }

    getGuestKey(){
    const keyObject = this.riderTypeMapping?.find(rider => rider.value === 'Guest');
    if (keyObject) {
       return keyObject.label;
    }
  }

  getSelfKey(){
    const keyObject = this.riderTypeMapping.find(rider => rider.value === 'Self');
    if (keyObject) {
       return keyObject.label;
    }
  }

  constructPayeeForm(payeeForm) {
    if (this.payerConfig && this.payerConfig.config.visibility.visible && this.paymentType === 'Bill To User') {
      const payeeArr = [];
      let payeeObj = {};
      let payerGuid = null;
      for (const payee of payeeForm.controls) {
        if (payee.controls['payerGuid'].value || payee.value.payerGuid) {
          payerGuid = payee.controls['payerGuid'].value || payee.value.payerGuid;
        }
        if (payee instanceof FormGroup) {
          payeeObj = { payerType: payee.controls['riderTypeId'].value, value: payee.controls['emplGuid'].value };
          payeeArr.push(payeeObj);
        }
      }
      this.payeeOptions = payeeArr;
      this.selectedPayer = this.selectedPayer ? this.selectedPayer : payerGuid ?
        payerGuid : this.payeeOptions[0] && this.payeeOptions[0].value;
      this.commonBookingService.getSelectedPayer(this.selectedPayer);
    }
  }

  removeRiderFromTrips(removedRider: any) {
    const removedRiderId = removedRider.travellerId;
    const newRiders = this.createBookingService.newRiders;
    if (newRiders.indexOf(removedRiderId) > -1) {
      newRiders.splice(newRiders.indexOf(removedRiderId), 1);
      return;
    }
    const dateFormArray = this.tripFormDetails.get('dateWise');
    if (dateFormArray instanceof FormArray && dateFormArray.length) {
      for (const dateForm of dateFormArray.controls) {
        if (dateForm instanceof FormGroup) {
          const cabs = dateForm.get('cabs');
          if (cabs instanceof FormArray && cabs.length) {
            for (const cab of cabs.controls) {
              const stops = cab.get('stops');
              if (stops instanceof FormArray) {
                for (const stop of stops.controls) {
                  const riders = stop.get('riders');
                  if (riders instanceof FormArray && riders.length) {
                    for (let i = 0; i < riders.length; i++) {
                      const rider = riders.at(i);
                      if (rider instanceof FormGroup && rider.get('name').value === removedRiderId) {
                        riders.removeAt(i);
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  addRiderState(formDetails: FormGroup, riderInfo?: any) {
    // check if there are any empty fields
    let emptyFieldsCount = 0;
    if (riderInfo) {
      for (const field of this.formConfig) {
        if (formDetails.get(field.elementKey)) {
          if (!formDetails.get(field.elementKey).value) {
            emptyFieldsCount++;
          } else {
            if (!['costCenter', 'department', 'alternatePhoneCode','phoneCode'].includes(field.elementKey)){
              formDetails.get(field.elementKey).disable({ onlySelf: true });
            }
          }
        }
      }
      if (!emptyFieldsCount) {
        formDetails.disable({ onlySelf: true });
      }
    }

    // add to formArray and riderStateArray
    this.riderStateArray.push({
      isEditActive: !riderInfo ? true : (emptyFieldsCount ? true : false)
    });
  }

  onEditClick(index: number) {
    this.editRiderInfo = true;
    if(this.riderStateArray[index]){
      this.riderStateArray[index].isEditActive = true;
      this.riderStateArray[index].currentState = this.formArray.at(index).getRawValue();
    }
      this.selectedRider = this.formArray.at(index).get('riderType').value;
  }

  onDeleteClick(index: number, form?) {

    this.riderStateArray.splice(index, 1);
    const removedRider = this.formArray.at(index).getRawValue();
    const riderAddr = this.riderAddress.filter((address) => address.employeeId !== removedRider.emplId);
    this.commonBookingService.updateHomeAddressesOfRiders(riderAddr);
    if (removedRider.riderTypeId === 'Self') {
      this.commonService.setValue('1');
      this.isSelfRider = false;
      this.changeDetectorRef.detectChanges();
    }
    this.formArray.removeAt(index);
    if (this.etsValuesMandatory) {
      if (this.formArray.controls.length) {
        for (let i = 0; i < this.formArray.controls.length; i++) {
          this.checkMobileNumberInEts(i);
        }
      } else {
        this.phoneNumberInEtsMandatory[0] = false;
      }

    }
    this.removeRiderFromTrips(removedRider);
    if (this.formArray.length) {
      this.selectedPayer = this.formArray.controls[0].get('emplGuid').value;
      this.constructPayeeForm(this.formArray);
    } else {
      this.commonBookingService.getSelectedPayer(null);
    }
    if (this.commonService.workflowConfig.riderLimit) {
    this.riderLimitReached = this.formArray.length == this.commonService.workflowConfig.riderLimit ? true : false;
    }
  }

  onSaveClick(index: number) {
    if (this.formArray.at(index).valid) {
      this.riderStateArray[index].isEditActive = false;
    } else {
      this.markFormGroupDirty(this.formArray.at(index));
    }
  }

  onCancelClick(index: number) {
    this.riderStateArray[index].isEditActive = false;
    if (this.riderStateArray[index].currentState) {
      this.formArray.at(index).patchValue(this.riderStateArray[index].currentState);
      this.riderStateArray[index].currentState = null;
    } else {
      this.onDeleteClick(index);
    }
  }

  getUserOptionLabel(option: any) {
    return `${option.employeeName} (${option.employeeId})`;
  }

  getUserOptionValue(option: any) {
    return option;
  }

  onRiderSelect(riderObj: any) {

    const findIndex = this.formArray.controls.findIndex((formGroup) => {
      return formGroup.controls.emplGuid.value === riderObj.guid;
    });
    if (findIndex === -1) {
      this.duplicateRiderMsg = "";
      riderObj.primaryAddress.home.employeeId = riderObj.employeeId;
      riderObj.primaryAddress.home.isSaved = true;
      riderObj.primaryAddress.home.type = `${riderObj.employeeName}'s Home`;
      this.riderAddress.push(riderObj.primaryAddress.home);
      this.commonBookingService.updateHomeAddressesOfRiders(this.riderAddress);
      this.updateTableWithRider(this.formatRiderInfo(riderObj,
        this.currentUser.employeeId === riderObj.employeeId ? 'Self' : 'Firm Member'
      ));
      if (this.etsValuesMandatory) {
        this.checkMobileNumberInEts(this.formArray.length - 1);
      }
    } else {
      this.duplicateRiderMsg = "Duplicate Rider is not allowed";
    }
      }
   getByValue(map, searchValue) {
    const item = map.find((item) => item?.value === searchValue);
    return item?.label;
  }
  onRiderChange(evt) {
    this.selectedPayer = evt;
    this.commonBookingService.getSelectedPayer(this.selectedPayer);
  }
  ngOnDestroy() {
    // this.formArray.value.forEach(item=>
    //   this.riderGuidList.push(item.emplGuid)
    // )
    this.formArray.controls.forEach(control => {
      const emplGuid = control.get('emplGuid').value;
      this.riderGuidList.push(emplGuid);
    });


    this.createBookingService.riderGuid.next(this.riderGuidList);

    this.watchers.forEach((watcher) => {
      watcher.unsubscribe();
    });
    this.destroy$.next();
    this.destroy$.complete();
  }

/*   paginate(event: any) {
    this.pageIndex = event;
    this.dataSource = new MatTableDataSource(this.tabledataSource.slice(event * this.tableSize - this.tableSize, event * this.tableSize));
  }
  showNumberOfRecords(index: any) {
    this.tableSize = index;
    this.dataSource = new MatTableDataSource(this.tabledataSource.slice(this.p * this.tableSize - this.tableSize, this.p * this.tableSize));
  } */

  checkTyping(event) {
    const str = event.target.value;
    if (str.length) {
        this.isTyped = false;
    } else {
        this.isTyped = true;
    }
}
  resetSearchInput() {
    this.searchTerm = "";
    this.isTyped = true;
}

onRequesterSelect(ev) {

  this.requester = ev.value;
}
countryCodeSelection(event, data, editrider) {
  if (editrider )
  {
    editrider.currentState.phoneCode = event.value;
  }
  if (event === '')
  {
    return { label: ' + 91 ', value: '91' };
  }
  const code = event.label.split(" ");
  this.selectedCountryCode = {
    label: `+ ${code[1]}`,
    value: event.value
  };
  data.setValue(code[1]);
  this.selectCountryCode(this.selectedCountryCode);
  return this.selectedCountryCode;
}
getDriverPhone(e, form){
  const inputValue = e.target.value;
  const numericOnly = inputValue.replace(/\D/g, '');
  form.value = numericOnly.toString();

}

onCodeChange($event, form: FormControl)
{
form.setValue($event);

}

getRiderInfo(rider, val: string, editrider){

  if (editrider && editrider?.currentState?.phoneCode !== rider.get(val)?.value)
  {
    rider.get(val).value = editrider.currentState.phoneCode;
  }
  if (rider.get(val).value){
  if (rider.get(val).value === '') {
  rider.get(val).value = '91';
  }
else if (rider.get(val).value.includes('+')) {
  return rider?.get(val)?.value;
 }
else {
  return '+' + rider?.get(val)?.value;
 }
 }

}

selectCountryCode(event: any): any {
  return event === "" ? { label: ' + 91 ', value: '91' } : event;
}

onWhatsappCheck(event){
  this.createBookingService.getWhatsappNotify.next(event.value);
}
}
